import { Button } from "V2.0/common/button";
import { ArrowLeftIcon } from "@heroicons/react/24/outline";
import { useNavigate, useLocation } from "react-router-dom";

/* width is opt-in and defaults to the original 500px, so every existing integration renders
   exactly as before. Field mapping needs more room than a credentials form. */
export function IntegrationShell({children, width = "w-[500px]" }) {
  const navigate = useNavigate();
  const location = useLocation();
  return (
    <div class="w-full flex flex-col items-center p-16">
      <div className="flex flex-col gap-y-4">
        <div>
          <Button plain onClick={() => navigate({
            pathname: "/integrations",
            search: location.search
          })}>
            <ArrowLeftIcon />
            back
          </Button>
        </div>
        <div className={width}>
          {children}
        </div>
      </div>
    </div>
  );
}
